import { API } from "."
import {
  ReadTeamCoachListResponse,
  UpsertCoachPayload,
  CreateCoachPayload,
  JoinCoachPayload,
} from "@/types/coach"

/* 호출 시 /teams/{idfTeam} 추가 */

/* 팀 코치 목록 조회 */
export async function readTeamCoachList() {
  return await API.get<ReadTeamCoachListResponse>(`/coaches`)
}

/* 팀 코치 역할 수정 */
export async function upsertCoach(data: { idfCoach: number; payload: UpsertCoachPayload }) {
  const { idfCoach, payload } = data

  return await API.put<void>(`/coaches/${idfCoach}`, payload)
}

// TODO delete 수정 필요
/* 팀 코치 방출 */
export async function upsertCoachLeave(idfCoach: number) {
  return await API.put<void>(`/coaches/${idfCoach}/leave`)
}

/* 코치 계정 생성 및 팀 코치 추가 */
export async function createCoach(payload: CreateCoachPayload) {
  return await API.post<string>(`/coaches`, payload)
}

/* 팀 코치 추가 */
export async function joinCoach(data: { idfCoach: number; payload: JoinCoachPayload }) {
  const { idfCoach, payload } = data
  return await API.post<string>(`/coaches/${idfCoach}/join`, payload)
}
